import { contentRootTagName } from "@hightouch/lib/llm/lifecycle-studio/dynamic-content/shared";

/** Table sections parse (and render) only directly inside a `<table>`. */
export const TABLE_SECTION_TAGS = new Set(["tbody", "thead", "tfoot"]);

const WRAPPER_ATTRIBUTE = "data-ht-table-fragment-wrapper";

const WRAPPER_TABLE_OPEN = `<table ${WRAPPER_ATTRIBUTE} width="100%" cellpadding="0" cellspacing="0" border="0">`;

/** The fragment's own top-level elements in a document body, inside the
 *  `wrapTableFragment` wrapper or not. `:where()` keeps the specificity of
 *  `body > *`, so the content's own class rules still override rules on it. */
export const TABLE_FRAGMENT_ROOT_SELECTOR = `body > :where(:not([${WRAPPER_ATTRIBUTE}])), body :where([${WRAPPER_ATTRIBUTE}]) > :where(:not([${WRAPPER_ATTRIBUTE}]))`;

/** Wrap a table fragment so it parses/renders outside its original table.
 *  HTML whose root is not a cell, row, or table section passes through. */
export function wrapTableFragment(html: string): string {
  const tagName = contentRootTagName(html);
  if (tagName === "td" || tagName === "th") {
    return `${WRAPPER_TABLE_OPEN}<tbody ${WRAPPER_ATTRIBUTE}><tr ${WRAPPER_ATTRIBUTE}>${html}</tr></tbody></table>`;
  }
  if (tagName === "tr") {
    return `${WRAPPER_TABLE_OPEN}<tbody ${WRAPPER_ATTRIBUTE}>${html}</tbody></table>`;
  }
  if (tagName !== null && TABLE_SECTION_TAGS.has(tagName)) {
    return `${WRAPPER_TABLE_OPEN}${html}</table>`;
  }
  return html;
}
